import styled from 'styled-components'

export const font = '"Roboto", Arial, Helvetica, sans-serif'

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  position: relative;
  z-index: 1;
`

export const StyledTitle = styled.h2`
  font-size: 24px;
  font-family: ${font};
  font-weight: 600;
  line-height: 1.5;
  color: #282832;
  margin: 0;
`

export const StyledCloseButton = styled.button`
  width: 24px;
  height: 24px;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
`

export const StyledBalance = styled.div`
  align-self: stretch;
  padding: 8px 16px;
  background: #F3FCFF;
  border-radius: 8px;
  outline: 1px #004C80 solid;
  outline-offset: -1px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
`

export const StyledBalanceColumn = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`

export const StyledBalanceLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.4;
  color: #282832;
`

export const StyledBalanceValue = styled.p`
  font-size: 18px;
  font-family: ${font};
  font-weight: 600;
  line-height: 1.65;
  color: #282832;
  margin: 0;
`

export const StyledDividerVertical = styled.div`
  width: 1px;
  height: 56px;
  background: #004C80;
  flex-shrink: 0;
`

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const StyledLabel = styled.p`
  font-size: 14px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.65;
  color: #282832;
  margin: 0;
`

export const StyledStepper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background: white;
  border-radius: 8px;
  outline: 1px #9DA0B2 solid;
  outline-offset: -1px;
`

export const StyledStepperButton = styled.button<{ disabled?: boolean }>`
  width: 40px;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 20px;
  outline: 1px #D4D4D6 solid;
  outline-offset: -1px;
  border: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  font-size: 20px;
  font-family: ${font};
  color: #3F444F;
`

export const StyledStepperCenter = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledStepperAmount = styled.span`
  font-size: 28px;
  font-family: ${font};
  font-weight: 600;
  color: #59C369;
`

export const StyledStepperHint = styled.p`
  font-size: 12px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.4;
  color: #5E5E65;
  text-align: center;
  margin: 0;
`

export const StyledOrderSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  outline: 1px #9DA0B2 solid;
  outline-offset: -1px;
`

export const StyledOrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const StyledOrderLabel = styled.span`
  font-size: 14px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.65;
  color: #282832;
`

export const StyledOrderValue = styled.span<{ highlight?: boolean; bold?: boolean }>`
  font-size: 14px;
  font-family: ${font};
  font-weight: ${({ bold }) => bold ? 600 : 400};
  line-height: 1.65;
  color: ${({ highlight }) => highlight ? '#59C369' : '#282832'};
`

export const StyledDivider = styled.div`
  height: 1px;
  background: #D4D4D6;
`

export const StyledRedeemButton = styled.button`
  align-self: stretch;
  width: 100%;
  height: 40px;
  background: #FFCD05;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-family: ${font};
  font-weight: 600;
  line-height: 1.65;
  color: #282832;
`

export const StyledDisclaimer = styled.p`
  font-size: 12px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.4;
  color: #282832;
  margin: 0;
`

export const StyledDisclaimerLink = styled.a`
  color: #05629B;
  text-decoration: underline;
`

export const StyledTooltip = styled.div`
  padding: 8px;
  background: white;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  font-size: 12px;
  font-family: ${font};
  font-weight: 400;
  line-height: 1.4;
  color: #333333;
`

export const StyledYourfullPointsBalance = styled.span`
  color: #333333;
  font-size: 12px;
  font-family: ${font};
  font-weight: 400;
  line-height: 19.80px;
  word-wrap: break-word;
`

export const StyledYourfullPointsBalanceWecapRedemption = styled.p`
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

export const StyledRewardRedeemedAppliesOnly = styled.span`
    color: #333333;
    font-size: 12px;
    font-family: ${font};
    font-weight: 400;
    line-height: 19.80px;
    word-wrap: break-word;
`

export const StyledRewardRedeemedAppliesOnlyToSubtotal = styled.p`
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
`